import { DeliveryEstimate } from "@redotech/redo-model/conversion/conversion-autocheck";
import { InsertionPosition } from "@redotech/redo-model/widget";
import { useMemo } from "react";
import { log } from "../../monitoring/log";
import { RedoDeliveryEstimateContainerElement } from "./element";
import { STYLE_DISPLAY_UNSET } from "./use-render-pdps";

const positionMap: Record<InsertionPosition, InsertPosition> = {
  [InsertionPosition.BEFORE]: "beforebegin",
  [InsertionPosition.AFTER]: "afterend",
  [InsertionPosition.PREPEND]: "afterbegin",
  [InsertionPosition.APPEND]: "beforeend",
};

type CartPortal = {
  foundSelector?: string;
  portal: RedoDeliveryEstimateContainerElement;
};

const CART_DELIVERY_ESTIMATE_CONTAINER_ID =
  "redo-delivery-estimate-cart-container";

export function useCartRenderPortals({
  deliveryEstimate,
}: {
  deliveryEstimate: DeliveryEstimate;
}): CartPortal[] {
  const renderCartPortals = useMemo(() => {
    const cartPortals: CartPortal[] = [];

    log("delivery estimate cartSelectors", deliveryEstimate.cartSelectors);

    if (deliveryEstimate.cartSelectors.length === 0) {
      return cartPortals;
    }

    // Register the custom element if not already registered
    RedoDeliveryEstimateContainerElement.register();

    for (const selectorConfig of deliveryEstimate.cartSelectors) {
      const containers = document.querySelectorAll(selectorConfig.selector);
      log(
        `delivery estimate cart containers for selector "${selectorConfig.selector}"`,
        containers,
      );

      for (const container of containers) {
        const cartElement = document.createElement(
          RedoDeliveryEstimateContainerElement.TAG,
        ) as RedoDeliveryEstimateContainerElement;
        cartElement.id = CART_DELIVERY_ESTIMATE_CONTAINER_ID;
        // This is needed to ensure the element is displayed, Shopify has a CSS
        // rule that hides empty divs, and this div is considered empty because
        // it only contains the shadow root.
        cartElement.style.display = STYLE_DISPLAY_UNSET;

        const insertPosition = positionMap[selectorConfig.insertPosition];
        container.insertAdjacentElement(insertPosition, cartElement);

        cartPortals.push({
          foundSelector: selectorConfig.selector,
          portal: cartElement,
        });
      }
    }

    return cartPortals;
  }, [deliveryEstimate.cartSelectors]);

  return renderCartPortals;
}
